import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { Supplier } from '../../shared/classes/supplier';
import { LoadingPopupComponent } from '../loading-popup/loading-popup.component';
import { UserService } from '../../shared/services/user/user.service';
import { firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-add-supplier',
    templateUrl: './add-supplier.component.html',
    styleUrls: ['./add-supplier.component.css'],
    standalone: true,
    imports: [FormsModule, MatDialogActions]
})
export class AddSupplierComponent {
    newSupplier: Supplier = new Supplier();

    /**
     * Constructs a new popup prompting the user to enter a supplier's information.
     */
    constructor(
        private dialogRef: MatDialogRef<AddSupplierComponent>,
        private loadingDialog: MatDialog,
        private userService: UserService
    ) {}

    /**
     * Close the popup and do not add a supplier.
     */
    cancel(): void {
        this.dialogRef.close(true);
    }

    /**
     * Close the popup and indicate the the supplier should be added.
     */
    submit(): void {
        const promise = (async (): Promise<void> => {
            await firstValueFrom(this.userService.createUser(this.newSupplier));
            this.dialogRef.close(true);
            window.location.reload();
        })();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            promise
        };
        this.loadingDialog.open(LoadingPopupComponent, dialogConfig);
    }
}
